import { Box, Typography } from "@mui/material";
import video from "../../assets/AdobeStock.mov";

function VideoSection() {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "1000px",
        overflow: "hidden",
      }}
    >
      {/* Видео-фон */}
      <Box
        sx={{
          position: "absolute",
          top: { xs: "-120px", md: "-40px", xl: "-70px" },
          left: 0,
          width: "100%",
          height: "100%",
        }}
      >
        <video
          autoPlay
          loop
          muted
          playsInline
          style={{
            // position: "absolute",
            // top: 0,
            // left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: 0,
          }}
        >
          <source src={video} type="video/mp4" />
          Ваш браузер не поддерживает видео.
        </video>
      </Box>

      {/* Затемнение для контраста */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          //   bgcolor:
          //     "linear-gradient(0deg, rgba(1, 2, 7, 0.2), rgba(1, 2, 7, 0.2)),linear-gradient(180deg, rgba(1, 2, 7, 0) 74.14%, #010207 92.62%);",
          zIndex: 1,
        }}
      />

      {/* Текст поверх видео */}
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          px: 2,
        }}
      >
        <Box>
          <Typography
            sx={{
              fontFamily: "Outfit",
              fontSize: { xs: "52px", sm: "80px" },
              lineHeight: { xs: "72px", sm: "90px" },
              fontWeight: 700,
              mt: { xl: "-50px" },
            }}
            color="white"
            gutterBottom
          >
            Where Resources
            <br /> Meet Precision
          </Typography>
          <Typography
            color="white"
            sx={{
              fontFamily: "Outfit",
              fontSize: { xs: "20px", sm: "30px" },
              fontWeight: 300,
            }}
          >
            Specialized in transporting critical resources —<br /> safely and on
            time
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default VideoSection;
